import { PRODUCT_TYPE } from '@ahmdigital/constants';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { Wrapper } from '@ahmdigital/ui';
import React from 'react';

import { ButtonWrapper, PriceBarWrapper, SelectedProductsWrapper, StyledButton, TotalPriceWrapper } from './styles';
import { JourneyProductType } from '../../types';
import { ProductType as ProductTypeType } from '../../../../types/__codegen__/ahm-api/graphql';
import buildYourCover from '../../../../actions/build-your-cover';
import ProductPricePill from './components/product-price-pill';
import ProductPriceTotal from './components/product-price-total';
import selectBuildYourCover from '../../../../selectors/select-build-your-cover';

const ReviewCoverButton = ({ journeyProductType }: { journeyProductType?: JourneyProductType }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { selectedProducts } = useSelector(selectBuildYourCover);

  const onReviewCoverClick = () => {
    buildYourCover.submitReview(selectedProducts, router, journeyProductType)(dispatch);
  };

  return (
    <StyledButton onClick={onReviewCoverClick} variant={['purple', 'wide']}>
      Review cover
    </StyledButton>
  );
};

const PriceBar = ({ journeyProductType }: { journeyProductType?: JourneyProductType }) => (
  <Wrapper size="large">
    <PriceBarWrapper>
      <SelectedProductsWrapper>
        {journeyProductType !== PRODUCT_TYPE.EXTRAS && <ProductPricePill productType={ProductTypeType.Hospital} />}
        <ProductPricePill productType={ProductTypeType.Extras} />
      </SelectedProductsWrapper>

      <TotalPriceWrapper data-testid="build-your-own-total-price">
        <ProductPriceTotal journeyProductType={journeyProductType} />
      </TotalPriceWrapper>

      <ButtonWrapper>
        <ReviewCoverButton journeyProductType={journeyProductType} />
      </ButtonWrapper>
    </PriceBarWrapper>
  </Wrapper>
);

export default PriceBar;
